import { UserCommunication } from '@this+that/models';

import { canArchiveUserCommunication } from '../utils/canArchiveUserCommunication';

export const useHasOnlySentEmails = (
  communications: UserCommunication[],
  selectedItems: Set<string>,
): { hasOnlySentEmails: boolean } => {
  const hasOnlySentEmails = (() => {
    const selectedCommunications = communications.filter((comm) =>
      selectedItems.has(comm.messageId),
    );

    if (selectedCommunications.length === 0) {
      return false;
    }

    return selectedCommunications.every(
      (comm) => !canArchiveUserCommunication(comm),
    );
  })();

  return { hasOnlySentEmails };
};
